import Api from "../axios";

export default async function apiDeleteHoliday({ id }) {
  return await Api.delete(`/delete_holiday?holiday_id=${id}`);
}
